/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";
import { withNoTranslate } from "i18n/noTranslate";
import React from "react";
import { changeStyleWithHosting } from "utility/hosting";

import type { FC } from "react";

type Props = {
  resaleTitle: string;
  resaleCloseAt: string;
  resaleResultAt: string;
  paymentMethod: string;
};

export const ResaleApplicationDetails: FC<Props> = ({
  resaleTitle,
  resaleCloseAt,
  resaleResultAt,
  paymentMethod,
}) => {
  const { t } = useI18n();
  const classes = styles();

  return (
    <section css={classes.root} aria-label={resaleTitle}>
      <div css={classes.heading}>
        <h2 css={classes.title} {...withNoTranslate()}>
          {resaleTitle}
        </h2>
        <span css={classes.status}>{t("event.resale.status.accepting")}</span>
      </div>
      <dl css={classes.details}>
        <div>
          <dt>{t("event.resale.applicationDeadline")}</dt>
          <dd {...withNoTranslate()}>{resaleCloseAt}</dd>
        </div>
        <div>
          <dt>{t("event.resale.lotteryResult")}</dt>
          <dd {...withNoTranslate()}>{resaleResultAt}</dd>
        </div>
        <div>
          <dt>{t("event.resale.entry.payment")}</dt>
          <dd {...withNoTranslate()}>{paymentMethod}</dd>
        </div>
      </dl>
    </section>
  );
};

const styles = () => {
  const { accentColor } = changeStyleWithHosting().baseStyles;

  return {
    root: css`
      border: 2px solid ${accentColor};
    `,
    heading: css`
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 12px;
      padding: 10px 12px;
      background-color: #e6fffa;
      @media screen and (min-width: 768px) {
        padding: 10px 16px;
      }
    `,
    title: css`
      margin: 0;
      font-size: 13px;
      font-weight: bold;
      line-height: 1.5;
      @media screen and (min-width: 768px) {
        font-size: 14px;
      }
    `,
    status: css`
      flex-shrink: 0;
      padding: 4px 10px;
      color: #fff;
      font-size: 12px;
      font-weight: bold;
      line-height: 1;
      background-color: #00b5d8;
      border-radius: 3px;
    `,
    details: css`
      margin: 0;
      & > div {
        display: grid;
        grid-template-columns: minmax(96px, auto) minmax(0, 1fr);
        align-items: center;
        gap: 12px;
        padding: 12px;
        border-top: 1px solid #e5e5e5;
        @media screen and (min-width: 768px) {
          grid-template-columns: 160px minmax(0, 1fr);
          padding: 12px 16px;
        }
      }
      dt {
        color: #777;
        font-size: 12px;
        line-height: 1.5;
      }
      dd {
        margin: 0;
        color: #222;
        font-size: 12px;
        font-weight: bold;
        line-height: 1.5;
        text-align: right;
      }
    `,
  };
};
